import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { QUERY_PARAMS, TOKEN_KEY } from '@shared/constants';

export const autoLoginGuard: CanActivateFn = (route, state) => {
  const accessToken = localStorage.getItem(TOKEN_KEY);
  if (!accessToken) {
    return true;
  }

  const router = inject(Router);
  router.navigate(['/'], {
    queryParams: {
      [QUERY_PARAMS.FROM_URL]: state.url
    }
  });
  return false;
};
